export const PROGRESS_GET_WEIGHINGS_BEGIN = 'PROGRESS_GET_WEIGHINGS_BEGIN';
export const PROGRESS_GET_WEIGHINGS_SUCCESS = 'PROGRESS_GET_WEIGHINGS_SUCCESS';
export const PROGRESS_GET_WEIGHINGS_FAILURE = 'PROGRESS_GET_WEIGHINGS_FAILURE';
export const PROGRESS_GET_WEIGHINGS_DISMISS_ERROR = 'PROGRESS_GET_WEIGHINGS_DISMISS_ERROR';
export const PROGRESS_CLEAR_WEIGHINGS = 'PROGRESS_CLEAR_WEIGHINGS';
export const PROGRESS_DELETE_WEIGHING = 'PROGRESS_DELETE_WEIGHING';
export const PROGRESS_CLEAR_ANALYSIS = 'PROGRESS_CLEAR_ANALYSIS';
export const PROGRESS_GET_WEIGHING_STATS_BEGIN = 'PROGRESS_GET_WEIGHING_STATS_BEGIN';
export const PROGRESS_GET_WEIGHING_STATS_SUCCESS = 'PROGRESS_GET_WEIGHING_STATS_SUCCESS';
export const PROGRESS_GET_WEIGHING_STATS_FAILURE = 'PROGRESS_GET_WEIGHING_STATS_FAILURE';
export const PROGRESS_GET_WEIGHING_STATS_DISMISS_ERROR =
  'PROGRESS_GET_WEIGHING_STATS_DISMISS_ERROR';
export const PROGRESS_GET_SENTIMENT_ANALYSIS_BEGIN = 'PROGRESS_GET_SENTIMENT_ANALYSIS_BEGIN';
export const PROGRESS_GET_SENTIMENT_ANALYSIS_SUCCESS = 'PROGRESS_GET_SENTIMENT_ANALYSIS_SUCCESS';
export const PROGRESS_GET_SENTIMENT_ANALYSIS_FAILURE = 'PROGRESS_GET_SENTIMENT_ANALYSIS_FAILURE';
export const PROGRESS_GET_SENTIMENT_ANALYSIS_DISMISS_ERROR =
  'PROGRESS_GET_SENTIMENT_ANALYSIS_DISMISS_ERROR';
export const PROGRESS_GET_USER_DASS_RESULT_LOADING = 'PROGRESS_GET_USER_DASS_RESULT_LOADING';
export const PROGRESS_GET_USER_DASS_RESULT_SUCCESS = 'PROGRESS_GET_USER_DASS_RESULT_SUCCESS';
export const PROGRESS_GET_USER_DASS_RESULT_FAILURE = 'PROGRESS_GET_USER_DASS_RESULT_FAILURE';
export const PROGRESS_GET_BLOOD_SUGARS_BEGIN = 'PROGRESS_GET_BLOOD_SUGARS_BEGIN';
export const PROGRESS_GET_BLOOD_SUGARS_SUCCESS = 'PROGRESS_GET_BLOOD_SUGARS_SUCCESS';
export const PROGRESS_GET_BLOOD_SUGARS_FAILURE = 'PROGRESS_GET_BLOOD_SUGARS_FAILURE';
export const PROGRESS_GET_BLOOD_SUGARS_DISMISS_ERROR = 'PROGRESS_GET_BLOOD_SUGARS_DISMISS_ERROR';
export const PROGRESS_GET_WAISTLINES_BEGIN = 'PROGRESS_GET_WAISTLINES_BEGIN';
export const PROGRESS_GET_WAISTLINES_SUCCESS = 'PROGRESS_GET_WAISTLINES_SUCCESS';
export const PROGRESS_GET_WAISTLINES_FAILURE = 'PROGRESS_GET_WAISTLINES_FAILURE';
export const PROGRESS_GET_WAISTLINES_DISMISS_ERROR = 'PROGRESS_GET_WAISTLINES_DISMISS_ERROR';
export const PROGRESS_GET_USER_ASSESSMENTS_RESULT_SUCCESS = 'PROGRESS_GET_USER_ASSESSMENTS_RESULT_SUCCESS';
export const PROGRESS_GET_USER_ASSESSMENTS_RESULT_FAILURE = 'PROGRESS_GET_USER_ASSESSMENTS_RESULT_FAILURE';
export const PROGRESS_GET_USER_ASSESSMENTS_RESULT_LOADING = 'PROGRESS_GET_USER_ASSESSMENTS_RESULT_LOADING';



// WEBPACK FOOTER //
// ./src/features/progress/redux/constants.js